export default function CursorSelector() {
  // Component disabled - using default browser cursor
  return null;
}
